<template>
  <div class="relative">
    <div class="grid" style="grid-template-columns: 1fr 324px; height: 67vh;">
      <div class="relative">
        <!-- 네이버 지도 -->
        <div id="map" style="width:100%; height:100%;"></div>

        <!-- 그리기 툴 -->
        <div v-if="isBaseOverlay" id="custom-toolbar" class="text-center" style="font-size: 12px;">
          <div @click="onClickDrawingMode('HAND')"
               :class="drawingManagerMode.isHand && 'active'">
            <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 13L3 1V21L9.5 14L19 13Z" stroke="#555555" stroke-width="2" stroke-linejoin="round"/>
            </svg>
            <span>{{ $t('선택/수정') }}</span>
          </div>
          <div @click="onClickDrawingMode('POLYGON')"
               :class="drawingManagerMode.isPoly && 'active'">
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.97826 22L2.5 2L13.8043 10L22.5 6V16.2222L5.97826 22Z" fill="#7E72F2" fill-opacity="0.6" stroke="#7E72F2" stroke-width="2" stroke-linejoin="round"/>
            </svg>
            <span>{{ $t('다각형') }}(Polygon)</span>
          </div>
          <div @click="onClickDrawingMode('ELLIPSE')"
               :class="drawingManagerMode.isEllipse && 'active'">
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12.5" cy="12" r="10" fill="#7E72F2" fill-opacity="0.6" stroke="#7E72F2" stroke-width="2" stroke-linejoin="round"/>
            </svg>
            <span>{{ $t('타원') }}(Ellipse)</span>
          </div>
          <div @click="onClickDrawingMode('RECTANGLE')"
               :class="drawingManagerMode.isRect && 'active'">
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2.5" y="2" width="20" height="20" fill="#7E72F2" fill-opacity="0.6" stroke="#7E72F2" stroke-width="2" stroke-linejoin="round"/>
            </svg>
            <span>{{ $t('사각형') }}(Rectangle)</span>
          </div>
        </div>

        <!-- 지도유형 -->
        <div class="flex gap-2" style="position: absolute; top: 15px; right: 15px;">
          <vs-button class="p-3" type="border" color="secondary" style="background: #fff !important;" @click="onClickMapType('NORMAL')">{{ $t('일반지도') }}</vs-button>
          <vs-button class="p-3" type="border" color="secondary" style="background: #fff !important;" @click="onClickMapType('SATELLITE')">{{ $t('위성지도') }}</vs-button>
          <vs-button class="p-3" type="border" color="secondary" style="background: #fff !important;" @click="onClickMapType('TERRAIN')">{{ $t('지형지도') }}</vs-button>
        </div>

        <!-- 레이어 -->
        <div style="position: absolute; bottom: 15px; left: 15px; background-color: #fff; border: 1px solid #CDCDCD; border-radius: 10px;">
          <div class="grid">
            <span v-for="(layer, index) in layerList" :key="`layer_${layer}`"
                  class="px-4 py-2 text-center cursor-pointer"
                  :class="[index !==0 && 'border-top']"
                  style="font-weight: 500; color:#696D71"
                  :style="selectLayer === layer ? {
                   backgroundColor: '#E2E0FA',
                   borderTopLeftRadius: index === 0 ? '10px' : '0px',
                   borderTopRightRadius: index === 0 ? '10px' : '0px',
                   borderBottomLeftRadius: index === layerList.length -1 ? '10px' : '0px',
                   borderBottomRightRadius: index === layerList.length -1 ? '10px' : '0px'
                 } : {}"
                  @click="() => {
                   selectLayer = layer
                   updateOverlays();
                 }"
            >
              {{ layer }}
            </span>
          </div>
        </div>
      </div>

      <div class="h-full grid overflow-hidden " style="background: #fff; border: 1px solid #cdcdcd; grid-template-rows: 1fr auto">
        <div class="py-6 overflow-auto">
          <div class="px-6">
            <div class="pb-4 border-bottom">
              <h3 class="mt-4 mb-2 px-2 flex items-center" style="font-size: 1.25rem;">{{ $t('위험설비 정보') }}</h3>
              <h3 class="mt-4 mb-2 px-2 flex items-center" style="font-size: 1rem;">{{ $t('구역명') }} *</h3>
              <ml-input readonly :value="barrierOverlayData.name"/>
            </div>
          </div>
          <div class="px-6">
            <div class="mb-4">
              <h3 class="mt-4 mb-2 px-2 flex items-center" style="font-size: 1rem;">{{ $t('설비 이름') }} *</h3>
              <ml-input :disabled="!selectOverlay" :value="selectOverlayData.data.text" @input="(text)=> {
                selectOverlayData.data.text = text;
                onChangeMarkerData();
              }" />
            </div>
            <div class="mb-4">
              <h3 class="mt-4 mb-2 px-2 flex items-center" style="font-size: 1rem;">{{ $t('설비 설명') }}</h3>
              <ml-textarea :disabled="!selectOverlay" :value="selectOverlayData.data.description" rows="4" @input="(description)=> {
                selectOverlayData.data.description = description;
                onChangeMarkerData();
              }" />
            </div>
            <!--            <div class="mb-4">-->
            <!--              <h3 class="mt-4 mb-2 px-2 flex items-center" style="font-size: 1rem;">{{ $t('알림 종류') }} *</h3>-->
            <!--              <vs-select disabled autocomplete v-model="selectOverlayData.data.eventType" class="w-full mb-2" @input="onChangeMarkerData">-->
            <!--                <vs-select-item :value="'enter'" :text="$t('진입 시 알림')" />-->
            <!--                <vs-select-item :value="'overstay'" :text="$t('체류 시간 초과 시 알림')" />-->
            <!--              </vs-select>-->
            <!--              <vs-select disabled v-if="selectOverlayData.data.eventType === 'overstay'" autocomplete v-model="selectOverlayData.data.stayTime" class="w-full" @input="onChangeMarkerData">-->
            <!--                <vs-select-item :value="'00:10:00'" :text="$t('10분 이상 체류 시')" />-->
            <!--              </vs-select>-->
            <!--            </div>-->
            <div class="mb-4">
              <h3 class="mt-4 mb-2 px-2 flex items-center" style="font-size: 1rem;">{{ $t('면 색상') }}</h3>
              <color-picker :disabled="!selectOverlay" v-model="selectOverlayData.ui.fillColor" @input="onChangeMarkerData"/>
            </div>
            <div class="mb-4">
              <h3 class="mt-4 mb-2 px-2 flex items-center" style="font-size: 1rem;">{{ $t('외곽선 색상') }}</h3>
              <color-picker :disabled="!selectOverlay" v-model="selectOverlayData.ui.strokeColor" @input="onChangeMarkerData"/>
            </div>
          </div>
        </div>
        <div v-if="selectOverlay" class="w-full flex gap-2 p-4" style="background: #fff; border-top: 1px solid #cdcdcd;">
          <vs-button type="border" class="py-2 px-5" @click="deleteOverlay">{{ $t('삭제') }}</vs-button>
          <vs-button type="border" class="py-2 px-5 ml-auto" @click="cancelOverlay">{{ $t('취소') }}</vs-button>
          <vs-button class="py-2 px-5" @click="saveOverlay">{{ $t('저장') }}</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FATabs from "@/components/FATabs.vue";
import * as UiUtil from "@/util/UiUtil";
import DrawingHandler, { DrawingSerialize } from "./drawing-handler";
import ColorPicker from "@/components/ColorPicker.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import HttpRequest from "@/util/HttpRequest";

export default {
  name: 'SetDangerZone',
  components: {FieldSelector, ColorPicker, FATabs },
  props: {

  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    isMobile () {
      return !(this.$store.state.verticalNavMenuWidth === 'default')
    },
    drawingManagerMode() {
      const mode = this.drawingManager ? this.drawingManager.getOptions("drawingMode") : null;
      let isHand = false;
      let isRect = false;
      let isEllipse = false;
      let isPoly = false;

      if (naver) {
        isHand = mode === naver.maps.drawing.DrawingMode.HAND
        isRect = mode === naver.maps.drawing.DrawingMode.RECTANGLE
        isEllipse = mode === naver.maps.drawing.DrawingMode.ELLIPSE
        isPoly = mode === naver.maps.drawing.DrawingMode.POLYGON
      }
      return {
        mode,
        isHand,
        isRect,
        isEllipse,
        isPoly
      }
    }
  },
  data() {
    return {
      map: undefined,
      mapHandler: undefined,
      drawingManager: undefined,

      layerList: ['2','1','B1'],
      selectLayer: '1',

      overlays: [],
      selectOverlay: undefined,
      selectOverlayData: new DrawingSerialize(),
      oldSelectOverlayData: new DrawingSerialize(),

      isBaseOverlay: false,
      barrierOverlayData: {
        id: undefined,
        name: '',
        fieldId: undefined,
        fieldName: ''
      }
    };
  },
  methods: {
    async initMap(lat, lng) {

      if (this.mapHandler) return;
      this.map = await new naver.maps.Map('map', {
        center: await new naver.maps.LatLng(lat || 35.00028333, lng || 128.0667778),
        zoom: 12,
        // 확대/축소 컨트롤러 옵션
        zoomControl: true,
        zoomControlOptions: {
          position: naver.maps.Position.RIGHT_BOTTOM // 위치 조정 가능
        }
      });
      this.mapHandler = new DrawingHandler(this.map);
      this.mapHandler.addedOverlay = (overlay, serialize) => {
        console.log("신규도형 추가", overlay.serialize)
        if (!overlay.serialize.data.useBarrierOverlay && overlay.barrierOverlay) {
          overlay.serialize.data.etc.region_id = overlay.barrierOverlay.serialize.data.id;
          overlay.serialize.data.fieldId = overlay.barrierOverlay.serialize.data.fieldId;
          overlay.serialize.data.fieldName = overlay.barrierOverlay.serialize.data.fieldName;
        }
        if (!overlay.serialize.data.etc) overlay.serialize.data.etc = {}
        if (!overlay.serialize.data.etc.layer) overlay.serialize.data.etc.layer = this.selectLayer;
        this.overlays.push(overlay)
      }
      this.mapHandler.changedOverlayPosition = (overlay, serialize) => {
        console.log("도형 위치 변경", serialize)
      }
      this.mapHandler.setSelectOverlay = (overlay, serialize) => {
        if (overlay) {
          if (overlay.serialize.data && overlay.serialize.data.useBarrierOverlay) {
            if (overlay.setEditable) overlay.setEditable(false); // 편집 금지
            if (overlay.setDraggable) overlay.setDraggable(false); // 이동 금지
            this.setBarrierOverlay(overlay)
          } else {
            if (overlay.barrierOverlay) {
              this.setBarrierOverlay(overlay.barrierOverlay)
            } else if (overlay.serialize.data.etc.region_id) {
              overlay.barrierOverlay = this.setBarrierOverlayWithId(overlay.serialize.data.etc.region_id)
            }
            this.selectOverlay = overlay;
            this.selectOverlayData = serialize;
            this.oldSelectOverlayData = new DrawingSerialize(this.selectOverlayData);
          }

          const latlng = new naver.maps.LatLng(serialize.ui.baseCenter.lat, serialize.ui.baseCenter.lng)
          this.map.setCenter(latlng);
        } else {
          this.resetOverlaySerializeData();
          this.selectOverlay = undefined;
          this.selectOverlayData = new DrawingSerialize();
          this.setBarrierOverlay(null)
        }
      }
      this.mapHandler.outOfRange = () => {
        this.$toast.open({type: 'error', message: '기준 영역을 벗어났습니다', position: 'bottom', duration: 2000});
      }

      naver.maps.Event.once(this.map, 'init', () => {
        this.drawingManager = this.mapHandler.drawingManager;
      });
    },

    onChangeMarkerData () {
      if (this.selectOverlay) {
        this.selectOverlay.update(new DrawingSerialize(this.selectOverlayData))
      }
    },
    resetOverlaySerializeData () {
      if (this.selectOverlay) {
        this.selectOverlay.update(new DrawingSerialize(this.oldSelectOverlayData))
      }
    },
    updateOverlays() {
      this.overlays.forEach(overlay => {
        if (this.__checkFilter(overlay.serialize)) {
          overlay._marker.setMap(this.map);
          overlay.setMap(this.map);
        } else {
          overlay._marker.setMap(null);
          overlay.setMap(null);
        }
      });
    },
    // filter 조건에 일치하는지 체크
    __checkFilter(serialize) {
      let show = false;
      if (this.selectLayer === '1') {
        show = !serialize.data.etc || serialize.data.etc.layer === '1' || !serialize.data.etc.layer;
      } else {
        if (!serialize.data.etc) show = false
        else show = serialize.data.etc.layer === this.selectLayer;
      }
      return show;
    },
    async saveOverlay() {
      if (!this.selectOverlayData.text && !this.selectOverlayData.data.text) {
        const customAlert = new CustomEvent("customAlert", {
          detail: {
            title: this.$t('필수데이터 누락'),
            message: this.$t('설비 이름을 선택해주세요.'),
          },
        });
        window.dispatchEvent(customAlert);
        return;
      } else if (!this.selectOverlay.barrierOverlay || !this.selectOverlay.barrierOverlay.serialize.data || !this.selectOverlay.barrierOverlay.serialize.data.id) {
        console.log("barrierOverlay", this.selectOverlay.barrierOverlay)
        const customAlert = new CustomEvent("customAlert", {
          detail: {
            title: this.$t('위험구역 미설정'),
            message: this.$t('위험구역을 선택해주세요.'),
          },
        });
        window.dispatchEvent(customAlert);
        return;
      }


      const barrierOverlayData = this.selectOverlay.barrierOverlay.serialize.data
      this.oldSelectOverlayData = new DrawingSerialize(this.selectOverlay.serialize)
      const overlayData = this.oldSelectOverlayData;
      const option = {
        region_id: barrierOverlayData.id, // 연결하는 기준 영역 번호
        name: overlayData.data.text, // 설비 이름
        description: overlayData.data.description, // 설비에 대한 설명
        meta: JSON.stringify(overlayData), // 설비에 대한 메타 데이터
        project_id: this.projectId, // 연결하는 분야(프로젝트) 번호
      }
      if (overlayData.data.id) {
        await this.apiUpdateZone(overlayData.data.id, option);
      } else {
        await this.apiCreateZone(option);
      }

      // 선택 해제 및 그리기 모드 핸드로 변경
      this.mapHandler.setSelectOverlay(null); // 선택 해제, this.selectOverlayData 초기화됨
      this.mapHandler.setDrawingMode(naver.maps.drawing.DrawingMode.HAND);
    },
    cancelOverlay() {
      this.mapHandler.setDrawingMode(naver.maps.drawing.DrawingMode.HAND);
    },
    async deleteOverlay() {
      if (this.selectOverlayData.data.id) {
        await this.apiDeleteZone(this.selectOverlayData.data.id, (response) => {
          if (response) {
            this.mapHandler.deleteOverlay(this.selectOverlay);
          }
        });
      } else {
        this.mapHandler.deleteOverlay(this.selectOverlay);
      }
    },


    onClickMapType (type) {
      if (type === 'NORMAL') {
        this.map.setMapTypeId(naver.maps.MapTypeId.NORMAL);
      } else if (type === 'SATELLITE') {
        this.map.setMapTypeId(naver.maps.MapTypeId.SATELLITE);
      } else if (type === 'TERRAIN') {
        this.map.setMapTypeId(naver.maps.MapTypeId.TERRAIN);
      }
    },

    async apiLoadRegion() {
      try {
        const option = {params: {}}
        const api = '/api/v1/region';
        const response = await HttpRequest.get(api, option).catch(err => {  })
        if (response.data && response.data.length > 0) {
          response.data.forEach(region => {
            const overlayData = JSON.parse(region.meta)
            overlayData.data.id = region.id;
            overlayData.data.useBarrierOverlay = true;
            if (!overlayData.data.etc) overlayData.data.etc = {};
            if (!overlayData.data.etc.layer) overlayData.data.etc.layer = '1';
            this.mapHandler.addOverlay(overlayData)
          })
        }
      } catch (error) {
        console.log("apiLoadRegion error", error)
      }
    },
    async apiLoadZone() {
      try {
        const option = {params: {}}
        const api = '/api/v1/zone';
        const response = await HttpRequest.get(api, option).catch(err => {  })
        if (response.data && response.data.length > 0) {
          response.data.forEach(zone => {
            const overlayData = JSON.parse(zone.meta)
            overlayData.data.useBarrierOverlay = false;
            overlayData.data.id = zone.id;
            this.mapHandler.addOverlay(overlayData)
          })
        }
      } catch (error) {
        console.log("apiLoadZone error", error)
      }
    },
    async apiCreateZone(option) {
      if (option) {
        try {
          const api = '/api/v1/zone';
          const response = await HttpRequest.post(api, option).catch(err => {  })
          if (response && response.data) {
            const id = response.data.id;
            this.oldSelectOverlayData.data.id = id;
            this.selectOverlay.update(new DrawingSerialize(this.oldSelectOverlayData))
          }
        } catch (error) {
          console.log("apiCreateZone error", error)
        }
      }
    },
    async apiUpdateZone (id, option) {
      if (option) {
        try {
          const api = '/api/v1/zone/' + id;
          const response = await HttpRequest.put(api, option).catch(err => {  })
        } catch (error) {
          console.log("apiUpdateZone error", error)
        }
      }
    },
    async apiDeleteZone (id, callback) {
      if (id) {
        try {
          const api = '/api/v1/zone/' + id;
          const response = await HttpRequest.delete(api).catch(err => {
            let message = "삭제 중 오류가 발생했습니다.";
            if (err.response && err.response.data && err.response.data.error) {
              message = err.response.data.error;
            }
            const customAlert = new CustomEvent("customAlert", {
              detail: {
                title: "오류가 발생했습니다",
                message,
              },
            });
            window.dispatchEvent(customAlert);
          })
          if (callback) {
            callback(response);
          }
        } catch (error) {
          console.log("apiDeleteZone error", error)
        }
      } else {
        console.warn("zone id 가 없습니다.")
      }
    },
    setBarrierOverlay (overlay) {
      this.isBaseOverlay = overlay ? true : false;
      this.mapHandler.setBarrierOverlay(overlay)
      this.setBarrierOverlayData(overlay)
    },
    setBarrierOverlayWithId (id) {
      if (id) {
        const overlay = this.mapHandler.setBarrierOverlayWithId(id)
        this.isBaseOverlay = overlay ? true : false;
        this.setBarrierOverlayData(overlay)
        return overlay
      }
      return null;
    },
    setBarrierOverlayData(overlay) {
      if (overlay) {
        this.barrierOverlayData = {
          id: overlay.serialize.data.id,
          name: overlay.serialize.data.text || '',
          fieldId: overlay.serialize.data.fieldId || undefined,
          fieldName: overlay.serialize.data.fieldName || ''
        }
      } else {
        this.barrierOverlayData = {}
      }
    },
    onClickDrawingMode (mode) {
      if (mode === 'HAND') {
        this.mapHandler.setDrawingMode(naver.maps.drawing.DrawingMode.HAND);
      } else if (mode === 'RECTANGLE') {
        this.mapHandler.setDrawingMode(naver.maps.drawing.DrawingMode.RECTANGLE);
      } else if (mode === 'ELLIPSE') {
        this.mapHandler.setDrawingMode(naver.maps.drawing.DrawingMode.ELLIPSE);
      } else if (mode === 'POLYGON') {
        this.mapHandler.setDrawingMode(naver.maps.drawing.DrawingMode.POLYGON);
      }
    }
  },

  created() {
  },
  async mounted() {
    await this.initMap();
    await this.apiLoadRegion();
    await this.apiLoadZone();
    this.updateOverlays();
  }
}

</script>

<style scoped lang="scss">
#custom-toolbar {
  position: absolute;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  box-shadow: 0 2px 8px 0 #00000022;
  background: #fff;
  border-radius: 10px;
  padding: 7px;

  display: flex;

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 8px;
    padding: 7px;

    &.active {
      background-color: #EAE8FF;
    }
    &:hover {
      background-color: #EAE8FF;
    }
  }
}
</style>
